import { z } from 'zod'

export const ProductStatus = z.object({
  status: z.enum(['active', 'canceled', 'suspended']).optional(),
  active_until: z
    .number()
    .int()
    .min(-9_223_372_036_854_775_808)
    // eslint-disable-next-line no-loss-of-precision
    .max(9_223_372_036_854_775_807)
    .optional(),
  features_used: z.map(z.string(), z.any()).optional()
})

export type ProductStatus = z.infer<typeof ProductStatus>
